module.exports = __webpack_public_path__ + "static/media/quieromibarrio3.a34fc900.jpg";